import { createReducer, on } from "@ngrx/store";
import { AppActions } from "./app.actions";

export const appFeatureKey = 'app'

export interface AppState {
  appIsLoading?: number | undefined;
  appError?: unknown | undefined;
  toolbarTitle?: string | undefined;
  toolbarIcon?: string | any | undefined;
  sidebarCollapsed?: boolean | undefined;
  rememberedUser?: string | undefined;
  pageSize?: number | undefined;
  loggedIn?: boolean | undefined;
}

const initialState: AppState = {
  appIsLoading: 0
}

export const appReducer = createReducer(
  initialState,
  on(AppActions.setToolbar, (state, action) => { return { ...state, toolbarTitle: action.payload.title, toolbarIcon: action.payload.icon } }),
  on(AppActions.unsetToolbar, (state) => { return { ...state, toolbarTitle: undefined, toolbarIcon: undefined } }),
  on(AppActions.setLoading, (state, action) => {
    const current = state.appIsLoading ?? 0;
    return {
      ...state,
      appIsLoading: action.loading ? current + 1 : Math.max(current - 1, 0)
    };
  }),
  on(AppActions.resetLoading, (state) => { return { ...state, appIsLoading: 0 } }),
  on(AppActions.setError, (state, action) => { return { ...state, appError: action.error, appIsLoading: 0 } }),
  on(AppActions.unsetError, (state) => { return { ...state, appError: undefined, appIsLoading: 0 } }),
  on(AppActions.setSidebar, (state, action) => { return { ...state, sidebarCollapsed: action.collapsed } }),
  on(AppActions.setRememberedUsername, (state, action) => { return { ...state, rememberedUser: action.usernameOrEmail } }),
  on(AppActions.setPagination, (state, action) => { return { ...state, pageSize: action.pageSize } }),
  on(AppActions.setLoggedStatus, (state, action) => { return { ...state, loggedIn: action.loggedIn } }),
)